import { gql } from '@zenbusiness/application-commons-graphql';

export const CANCEL_PAYMENT_MUTATION = gql`
  mutation cancel($input: CancelBankingPaymentInput!) {
    cancelBankingPayment(input: $input) {
      id
    }
  }
`;
